import { computed, Injectable, type Signal, signal } from '@angular/core';
import { LANG_LABELS } from '@constants';
import type { Lang, LangLabel } from '@appTypes';

/*
  Servicio de traducción de etiquetas
*/

type Translation = { label: LangLabel, $signal: Signal<string> };

@Injectable({
  providedIn: 'root',
})
export class Translate {
  // Signals / atributos
  private $_language = signal<Lang>('es');
  private translations: Translation[] = [];

  // Getters / setters

  get $language() {
    return this.$_language;
  }

  // Métodos

  // Devuelve un signal con la traducción de la etiqueta indicada
  private translate(label: LangLabel, targetLang?: Lang): Signal<string> {
    // Si se indicó un idioma objetivo, retornar un signal no computado
    if (targetLang)
      return signal(LANG_LABELS[targetLang][label]).asReadonly();

    // Buscar y retornar el signal computado correspondiente
    let translation: Translation | null = this.translations.find(translation => translation.label === label) ?? null;
    if (!translation) {
      translation = { label, $signal: computed(() => LANG_LABELS[this.$language()][label]) };
      this.translations.push(translation);
    }

    return translation.$signal;
  }

  // Devuelve la función de traducción con el binding adecuado
  translateFn() {
    return this.translate.bind(this);
  }
}
